module.exports = __webpack_public_path__ + "static/media/sourcing_cv.4833635d.jpeg";